export enum LayoutType {
    DEFAULT = 'DEFAULT',
    GRID = 'GRID'
}
